import { useMutation } from 'react-query';
import {
  getAllSyncStatusesAsync,
  getAllSyncSchedulesAsync,
  updateSyncScheduleAsync,
  triggerSyncNowAsync,
} from '../../index';

export const useGetAllSyncStatusesAsync = () =>
  useMutation(getAllSyncStatusesAsync);

export const useGetAllSyncSchedulesAsync = () =>
  useMutation(getAllSyncSchedulesAsync);

export const useUpdateSyncScheduleAsync = () =>
  useMutation(updateSyncScheduleAsync);

export const useTriggerSyncNowAsync = () => useMutation(triggerSyncNowAsync);
